import {
    ChangeDetectionStrategy,
    Component,
    inject,
    InjectionToken,
    Input,
    TemplateRef,
} from '@angular/core';
import {
    IconType,
    PlatformAuthService,
    ProfileProvider,
    SafeAny,
    TenantProvider,
} from '@pf/shared-common';
import { filter, first, Observable, of, tap } from 'rxjs';

import { BrandingService } from '../../../../services/branding.service';
import { LayoutService } from '../../services/layout.service';

export const MAIN_URL = new InjectionToken<string>('MAIN_URL');
export const IS_TEST_ENVIRONMENT = new InjectionToken<boolean>(
    'IS_TEST_ENVIRONMENT'
);

@Component({
    selector: 'pf-app-header',
    templateUrl: './app-header.component.html',
    styleUrls: ['./app-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AppHeaderComponent {
    layoutService = inject(LayoutService);
    brandingService = inject(BrandingService);
    profileProvider = inject(ProfileProvider);
    tenantProvider = inject(TenantProvider);
    authService = inject(PlatformAuthService);
    private mainUrl = inject(MAIN_URL);
    protected isTestEnvironment = inject(IS_TEST_ENVIRONMENT);

    private static readonly ENV_BANNER_KEY = 'pf-env-banner-hidden';

    environmentBannerType: IconType = localStorage.getItem(
        AppHeaderComponent.ENV_BANNER_KEY
    )
        ? IconType.view
        : IconType.hide;

    @Input() allowPasswordReset = true;
    @Input() menuItems: TemplateRef<SafeAny> | null | undefined;
    @Input() preLogoutAction?: () => Observable<boolean>;
    @Input() logoLink: string | string[] | null = null;
    @Input() showMenuIcon = true;

    constructor() {
        const brandingService = this.brandingService;
        const tenantProvider = this.tenantProvider;

        tenantProvider.branding$
            .pipe(
                filter(b => !!b),
                first()
            )
            .subscribe(branding => brandingService.updateBranding(branding));
    }

    logout() {
        (this.preLogoutAction?.() || of(true))
            .pipe(
                tap(shouldLogout => {
                    if (!shouldLogout) {
                        return;
                    }
                    this.authService.logout(this.mainUrl);
                })
            )
            .subscribe();
    }

    resetPassword() {
        this.profileProvider.resetPassword().subscribe(() => {
            // TODO show a notification that the password reset email has been sent // if the result is true
            // TODO show a notification that the password reset email has not been sent // if the result is false
        });
    }

    displayMenuFn() {
        this.layoutService.isHidden = !this.layoutService.isHidden;
    }

    switchEnvironmentBanner() {
        this.environmentBannerType =
            this.environmentBannerType === IconType.hide
                ? IconType.view
                : IconType.hide;

        if (this.environmentBannerType === IconType.view) {
            localStorage.setItem(AppHeaderComponent.ENV_BANNER_KEY, '1');
        } else {
            localStorage.removeItem(AppHeaderComponent.ENV_BANNER_KEY);
        }
    }

    protected readonly IconType = IconType;
}
